export default __webpack_public_path__ + "static/media/fb-1.da4d5f32.png";